import {
    GET_MANUFACTURER_LISTING,
    GET_MANUFACTURER_LISTING_SUCCESS,
    GET_MANUFACTURER_LISTING_FAIL,
    GET_MANUFACTURER_DETAILS,
    GET_MANUFACTURER_DETAILS_SUCCESS,
    GET_MANUFACTURER_DETAILS_FAIL,
    ADD_MANUFACTURER,
    ADD_MANUFACTURER_SUCCESS,
    ADD_MANUFACTURER_FAIL,
    UPDATE_MANUFACTURER,
    UPDATE_MANUFACTURER_SUCCESS,
    UPDATE_MANUFACTURER_FAIL,
    DELETE_MANUFACTURER,
    DELETE_MANUFACTURER_SUCCESS,
    DELETE_MANUFACTURER_FAIL,
    EXPORT_MANUFACTURER,
    EXPORT_MANUFACTURER_SUCCESS,
    EXPORT_MANUFACTURER_FAIL,
    RESET_MANUFACTURER_STATE,
    RESET_MANUFACTURER_ATTACHMENT_STATE,
} from "./actionTypes";

export const getManufacturerListing = (payload) => ({
    type: GET_MANUFACTURER_LISTING,
    payload: payload
});

export const getManufacturerListingSuccess = manufacturer => ({
    type: GET_MANUFACTURER_LISTING_SUCCESS,
    payload: manufacturer,
});

export const getManufacturerListingFail = error => ({
    type: GET_MANUFACTURER_LISTING_FAIL,
    payload: error,
});

export const getManufacturerDetails = manufacturerId => ({
    type: GET_MANUFACTURER_DETAILS,
    payload: manufacturerId,
});

export const getManufacturerDetailsSuccess = manufacturer => ({
    type: GET_MANUFACTURER_DETAILS_SUCCESS,
    payload: manufacturer,
});

export const getManufacturerDetailsFail = error => ({
    type: GET_MANUFACTURER_DETAILS_FAIL,
    payload: error,
});

export const createManufacturer = manufacturer => ({
    type: ADD_MANUFACTURER,
    payload: manufacturer,
});

export const createManufacturerSuccess = manufacturer => ({
    type: ADD_MANUFACTURER_SUCCESS,
    payload: manufacturer,
});

export const createManufacturerFail = error => ({
    type: ADD_MANUFACTURER_FAIL,
    payload: error,
});

export const updateManufacturer = manufacturer => ({
    type: UPDATE_MANUFACTURER,
    payload: manufacturer,
});

export const updateManufacturerSuccess = manufacturer => ({
    type: UPDATE_MANUFACTURER_SUCCESS,
    payload: manufacturer,
});

export const updateManufacturerFail = error => ({
    type: UPDATE_MANUFACTURER_FAIL,
    payload: error,
});

export const deleteManufacturer = manufacturerId => ({
    type: DELETE_MANUFACTURER,
    payload: manufacturerId,
});

export const deleteManufacturerSuccess = manufacturerId => ({
    type: DELETE_MANUFACTURER_SUCCESS,
    payload: manufacturerId,
});

export const deleteManufacturerFail = error => ({
    type: DELETE_MANUFACTURER_FAIL,
    payload: error,
});

export const exportManufacturer = data => ({
    type: EXPORT_MANUFACTURER,
    payload: data
});

export const exportManufacturerSuccess = data => ({
    type: EXPORT_MANUFACTURER_SUCCESS,
    payload: data,
});

export const exportManufacturerFail = error => ({
    type: EXPORT_MANUFACTURER_FAIL,
    payload: error,
});

//reset
export const resetManufacturerState = () => {
    return {
        type: RESET_MANUFACTURER_STATE,
    }
}
//reset attachment
export const resetManufacturerAttachmentState = () => {
    return {
        type: RESET_MANUFACTURER_ATTACHMENT_STATE,
    }
}

